import React from "react";
import { Box, Button, Stack } from "@mui/material";
import useMigrateToNewUi from "../../../../hooks/useMigrateToNewUi";

const NewUiBanner = () => {
  const { directToNewUi } = useMigrateToNewUi();
  return (
    <Box
      sx={{
        width: "100%",
        border: 1.5,
        p: 2,
        borderRadius: 3,
        mt: "26px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 2,
        }}
      >
        {/* Left Text Section */}
        <Box sx={{ flex: 1 }}>
          <div
            style={{
              color: "black",
              fontWeight: "500",
              fontSize: "18px",
            }}
          >
            🚀 The New Stayflexi is Here
          </div>

          <p
            className="font-weight-bold mt-2"
            style={{ color: "gray", textAlign: "left" }}
          >
            AI-powered, faster, smarter, and fully redesigned for modern
            hoteliers. Experience it now!
          </p>
        </Box>
      </Box>

      <Stack direction={"row"} spacing={2} mt={1}>
        <Button
          variant="custom-button"
          onClick={directToNewUi}
          sx={{ fontSize: "0.875rem", width: "fit-content" }}
        >
          Access New UI
        </Button>

        {/* <Button
          variant="outlined"
          onClick={() =>
            window.open("https://forms.gle/MMCamCx5mnRoH2Qs9", "_blank")
          }
          sx={{ fontSize: "0.875rem", width: "fit-content" }}
        >
          GIVE FEEDBACK
        </Button> */}
      </Stack>
    </Box>
  );
};

export default NewUiBanner;
